import * as React from "react";

import { CustomerNotificationLocation } from "@shared-ui/customer-notifications";

import { FlexComponent } from "src/typings/flexFramework/FlexComponent";
import { CustomerNotifications } from "components/shared/CustomerNotifications";
import { LobQueryRouter } from "components/shared/StorefrontWizard/LobQueryRouter";

export interface LobQueryRouterAndCustomerNotificationsProps {
  customerNotificationsClassName?: string;
  isStorefrontPage: boolean;
  wizardLOBs: FlexComponent[];
}

export const LobQueryRouterAndCustomerNotifications: React.FC<LobQueryRouterAndCustomerNotificationsProps> = ({
  customerNotificationsClassName = "",
  isStorefrontPage,
  wizardLOBs,
}) => (
  <>
    <LobQueryRouter lobs={wizardLOBs} />

    {isStorefrontPage && (
      <CustomerNotifications
        location={CustomerNotificationLocation.AFTER_HEADER}
        className={`customerNotificationSquare ${customerNotificationsClassName}`}
      />
    )}
  </>
);
